import styled from "styled-components";

export const CorperateProductSetFormStyled = styled.div`
  .form_layout {
    display: flex;
    align-items: flex-start;
    column-gap: 2rem;
    .form_left_col {
      flex: 1;
      max-width: 640px;
    }
    .form_right_col {
      flex: 0 0 300px;
      max-width: 300px;
      margin-left: auto;
    }
  }
  .input_row {
    margin-bottom: 16px;
    display: flex;
    width: 100%;
    .f_left_col {
      flex: 0 0 140px;
      padding-top: 8px;
    }
    .f_right_col {
      flex: 1;
      min-width: 0;
    }
  }
  .set_code_row {
    display: flex;
    column-gap: 0.75rem;
    .sc_col {
      flex: 1;
    }
  }
  .section_label {
    margin: 1.5rem 0 0.75rem 0;
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
  }
  .group_label {
    margin: 0.5rem 0 0.75rem 0;
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
  }
  .item_row {
    display: flex;
    align-items: center;
    column-gap: 1rem;
    .ir_col {
      flex: 1;
    }
    .btn_delete {
      cursor: pointer;
    }
  }
  .btn_add {
    padding: 4px 12px;
    border: none;
    border-radius: 1rem;
    cursor: pointer;
    background: ${({ theme }) => theme.COLORS.GRAY_4};
    color: ${({ theme }) => theme.COLORS.BLACK_2};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
  }
  .action_row {
    margin-top: 2rem;
    display: flex;
    justify-content: flex-end;
    column-gap: 10px;
    .btn_col {
      min-width: 130px;
      .btn {
        white-space: nowrap;
      }
    }
  }
  .required {
    margin-left: 2px;
    color: ${({ theme }) => theme.COLORS.RED_1};
  }
  .field_desc {
    margin-top: 4px;
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    color: ${({ theme }) => theme.COLORS.GRAY_2};
  }
  .list_errors {
    margin: -8px 0 12px 140px;
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    color: ${({ theme }) => theme.COLORS.RED_1};
  }
`;

export const SerialImportStyled = styled.div`
  .si_row {
    display: flex;
    align-items: center;
    column-gap: 10px;
    .si_file {
      flex: 1;
      min-width: 0;
      padding: 8px 12px;
      border: 1px solid ${({ theme }) => theme.COLORS.GRAY_7};
      border-radius: 1rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: ${({ theme }) => theme.COLORS.GRAY_2};
    }
    .si_btn {
      flex: 0 0 auto;
      min-width: 100px;
      .btn {
        white-space: nowrap;
      }
    }
  }
  .si_desc {
    margin-top: 4px;
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    color: ${({ theme }) => theme.COLORS.GRAY_2};
  }
`;

export const SerialImportModalStyled = styled.div`
  position: relative;
  border-radius: 1rem;
  width: 720px;
  max-width: 100%;
  max-height: calc(100vh - 80px);
  overflow-y: auto;
  padding: 20px;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  .btn_close_modal {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }
  .modal_title {
    margin-bottom: 0.5rem;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
  }
  .summary {
    margin-bottom: 0.75rem;
    .txt_green {
      color: #2e7d32;
    }
    .txt_red {
      color: #c62828;
    }
  }
  table {
    width: 100%;
    border-collapse: collapse;
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    th,
    td {
      padding: 6px 8px;
      border-bottom: 1px solid ${({ theme }) => theme.COLORS.GRAY_7};
      text-align: left;
    }
    .row_invalid td {
      color: #c62828;
    }
  }
  .modal_action {
    margin-top: 1rem;
    display: flex;
    justify-content: flex-end;
    column-gap: 10px;
    .w220 {
      min-width: 220px;
      .btn {
        white-space: nowrap;
      }
    }
  }
`;
